import { Route, Routes } from '@angular/router';
import { routeChangeActivateGuard, routeChangeDeactivateGuard } from './guards';
import { CmsPage } from './cms/cms.page';
import { layoutResolver, storyResolver } from '@seven1/angular-storyblok-components/resolver';
import { IAppLayoutConfig } from './cms/components/layout/cms-layout';
import redirectedRoutes from '../../public/data/redirectedRoutes.json';
import { environment } from '../environments/environment';

export const routes: Routes = [
    ...(redirectedRoutes as Route[]),
    {
        path: environment.cms.blogSlug,
        loadChildren: () => import('./blog').then(children => children.blog_routes)
    },
    {
        path: ':categoryId/' + environment.cms.blogSlug,
        loadComponent: () => import('./blog/category').then((page) => page.BlogCategoryPage),
        resolve: {
            story: storyResolver,
            layout: layoutResolver,
        },
        canActivate: [routeChangeActivateGuard],
        canDeactivate: [routeChangeDeactivateGuard],
    },
    {
        path: ':categoryId/' + environment.cms.blogSlug + '/:articleId',
        loadComponent: () => import('./blog/article').then((page) => page.BlogArticlePage),
        resolve: {
            story: storyResolver,
            layout: layoutResolver,
        },
        canActivate: [routeChangeActivateGuard],
        canDeactivate: [routeChangeDeactivateGuard],
    },
    {
        path: '**',
        component: CmsPage,
        resolve: {
            story: storyResolver,
            layout: layoutResolver<IAppLayoutConfig>,
        },
        canActivate: [routeChangeActivateGuard],
        canDeactivate: [routeChangeDeactivateGuard],
    },
];
